import script from "./BaseVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseVideo.vue?vue&type=script&setup=true&lang=js"

import "./BaseVideo.vue?vue&type=style&index=0&id=50310ef6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50310ef6"]])

export default __exports__